import { useTouchInput } from '../../../../components/touch/useTouchInput';
import { useCompactChart } from './useCompactChart';

/**
 * Whether the full-screen chart takes what is left under the toolbar (and the
 * values strip) instead of a height worked out from the window. True below
 * 900 px and on any touch screen: there the toolbar buttons are 44 px, a row
 * of them can wrap, and a phone on its side is only 360 to 430 px high, so a
 * fixed allowance for the controls either scrolls the card or wastes space.
 * A mouse at 900 px and wider keeps the sizing it always had.
 */
export function useFullscreenFill(): boolean {
    const compact = useCompactChart();
    const touch = useTouchInput();
    return compact || touch;
}
